import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { FormSection } from '../../../../elements/forms/formSection/FormSection';
import { RequestAssetThumbnails } from '../../../episodes/common';
import { getRequestFiles } from './RequestThumbnails';

export interface IRequestThumbnailsProps extends ICustomControlRequestReadProps {
    headerText: string;
}

export function RequestExaminationThumbnails(props: IRequestThumbnailsProps) {
    const requestFiles = getRequestFiles(props.request);

    if (requestFiles.length > 0) {
        return (
            <FormSection title={props.headerText}>
                <RequestAssetThumbnails
                    assets={requestFiles}
                    requestId={props.request.id}
                />
            </FormSection>
        );
    }

    return null;
}
